export default {
  commodity: ['commodity_management']
}
